import { useEffect } from 'react';
import { useQueryData } from './useQueryData';
import { useState } from 'react';
// @ts-expect-error - JS file
import { disableHubSpotCookieBanner } from '../utils/disableHubSpotCookieBanner';
import { setLoginMetadataCookieEnableAll } from '../utils/cookies';
import { setReauthCookie } from '../data/MobileReauthApi';
export const useMobileReauthCookie = () => {
  const [isMobileLogin, setIsMobileLogin] = useState(true);
  const {
    allQueryParams
  } = useQueryData();
  const reauth = allQueryParams.reauth;
  useEffect(() => {
    const setReauthCookieFromQueryParam = async () => {
      if (reauth) {
        const reauthCookie = Array.isArray(reauth) ? reauth[0] : reauth;
        await setReauthCookie(reauthCookie);
        setLoginMetadataCookieEnableAll();
        disableHubSpotCookieBanner();
        setIsMobileLogin(true);
      } else {
        setIsMobileLogin(false);
      }
    };
    void setReauthCookieFromQueryParam();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isMobileLogin;
};